import { render } from "./Anmeldung.vue?vue&type=template&id=fb22c7da&scoped=true"
import script from "./Anmeldung.vue?vue&type=script&lang=js"
export * from "./Anmeldung.vue?vue&type=script&lang=js"

import "./Anmeldung.vue?vue&type=style&index=0&id=fb22c7da&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb22c7da"]])

export default __exports__